import React from "react";
import "./Icon.scss";
import { IconProps } from "./Icon.types";
import { svgIconMap } from "./IconSvgMap";

// 获取图标尺寸
const getIconSize = (
  size: number | string | "sm" | "md" | "lg"
): number | string => {
  if (typeof size === "number") {
    return size;
  }

  switch (size) {
    case "sm":
      return "1rem";
    case "md":
      return "1.25rem";
    case "lg":
      return "1.5rem";
    default:
      return size;
  }
};

export const Icon: React.FC<IconProps> = ({
  name,
  className = "",
  size = "md",
  color,
  width,
  height,
  variant = "default",
  bgColor,
  onClick,
  disabled = false,
}) => {
  const iconSize = getIconSize(size);
  const iconWidth = width || iconSize;
  const iconHeight = height || iconSize;

  // 获取对应的SVG组件
  const SvgComponent =
    svgIconMap[name as keyof typeof svgIconMap] || svgIconMap.default;

  // 设置默认颜色（默认 currentColor，继承父元素 CSS color）
  const getIconColor = () => {
    if (color) return color;
    if (variant === "golden") return "url(#goldenGradient)";
    if (variant === "cream") return "#fff1b2";
    return "currentColor";
  };
  const iconColor = getIconColor();

  return (
    <span
      className={`icon icon--${variant} ${className}`.trim()}
      role="img"
      aria-label={name}
      onClick={disabled ? undefined : onClick}
      style={onClick && !disabled ? { cursor: "pointer" } : undefined}
    >
      <SvgComponent
        bgColor={bgColor}
        width={iconWidth}
        height={iconHeight}
        color={iconColor}
        variant={variant}
        onClick={undefined}
        disabled={disabled}
      />
    </span>
  );
};

export default Icon;
